import { pause_subscription_path } from '@routes';

import request from './request';

export interface PauseSubscriptionResponse {
  success: boolean;
  redirectUri: string;
}

export async function pauseSubscription(): Promise<PauseSubscriptionResponse> {
  const resp = await request('post', pause_subscription_path());
  return resp;
}
